import z from "zod";

export const refuseProofSchema = z.object({
  refusalReason: z.string().min(1),
  versions: z.array(
    z.object({
      versionId: z.string(),
      fileSignedId: z.string().optional(),
      versionName: z.string(),
    })
  ),
});

export type InferredRefuseProofSchema = z.infer<typeof refuseProofSchema>;

export const defaultValuesRefuseProof = (
  versions: Array<{ versionId: string; versionName: string }>
) => ({
  refusalReason: "",
  versions: versions.map((version) => ({
    versionId: version.versionId,
    fileSignedId: undefined,
    versionName: version.versionName,
  })),
});
